"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = exports.randomNumberCode = exports.randomSingleInt = void 0;
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const randomSingleInt = () => Math.floor(Math.random() * 10);
exports.randomSingleInt = randomSingleInt;
const randomNumberCode = (chars) => (0, lodash_1.join)((0, lodash_1.map)(Array(chars), exports.randomSingleInt), "");
exports.randomNumberCode = randomNumberCode;
exports.uuid = uuid_1.v4;
//# sourceMappingURL=random.js.map